<script setup lang="ts">
type Slots = {
  title?(): any;
  subtitle?(): any;
};

const slots = defineSlots<Slots>();
</script>

<template>
  <div class="dialog-header">
    <h2
      v-if="slots.title"
      class="text-2xl leading-8 p-6 pb-4 uppercase"
    >
      <slot name="title" />
    </h2>

    <p
      v-if="slots.subtitle"
      class="text-base leading-6 text-platform-text-2 px-6 pt-2 pb-4 flex flex-col"
    >
      <slot name="subtitle" />
    </p>
  </div>
</template>
